import { render, staticRenderFns } from "./ContentStatsView.vue?vue&type=template&id=6943cdb0&"
import script from "./ContentStatsView.vue?vue&type=script&lang=js&"
export * from "./ContentStatsView.vue?vue&type=script&lang=js&"
import style0 from "./ContentStatsView.vue?vue&type=style&index=0&id=6943cdb0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6943cdb0')) {
      api.createRecord('6943cdb0', component.options)
    } else {
      api.reload('6943cdb0', component.options)
    }
    module.hot.accept("./ContentStatsView.vue?vue&type=template&id=6943cdb0&", function () {
      api.rerender('6943cdb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/statistics/stats-tab-view/ContentStatsView.vue"
export default component.exports